<template>
  <div class="top">
    <header>
      <div class="mainTop">
        <img src="../assets/img/集团架构_banner.png" class="banner" />
        <div class="title">集团介绍</div>
      </div>
    </header>

    <main>
      <div class="main">
        <div class="center">
          <h1 class="groupIntroduction">集团介绍</h1>
          <!-- <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深圳昌恩智能股份有限公司成立于1998年5月22日，是经广东省公安厅、广东省住建厅批准认证、在建设“智慧城市”背景下为客户提供智能化整体解决方案的综合性企业。公司目前以城市和建筑智能化、智能交通为主营业务，建筑智能化服务领域遍及政府机构、金融行业、教育、医疗、公安边防、文博系统、旅游景点、小区酒店、智慧城市等，智能交通应用涉及出租车、网约车、两客一危及车辆运营监管平台等。
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司目前拥有广东省公安厅《广东省安全技术防范系统设计、施工、维修资格证（壹级）》、中国安防协会《安防工程企业设计施工维护能力证书（壹级）》、广东省住建厅《建筑业企业资质证书－电子与智能化工程专业承包一级》、深圳市住建局《建筑业企业资质证书－建筑机电安装工程专业承包二级》、中国电子信息行业联合会《信息系统建设和服务能力等级证书（CS2）》、广东省住建厅《安全生产许可证》、深圳市盐田区住建局《建筑业企业资质证书－施工劳务》。
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司先后获得《工程建设施工组织质量管理体系认证证书》、《环境管理体系认证证书》、《职业健康安全管理体系认证证书》、《两化融合管理体系评定证书》、《知识产权管理体系认证证书》、美国软件工程学会《CMMI３认证证书》。公司被认定为《网约车智能终端系统工程技术研究中心》、《国家高新技术企业》、《深圳双软企业》、《深圳市专精特新中小企业》。“昌恩智能”品牌入选第十六届、第十九届“深圳知名品牌”。
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2016年5月20日，昌恩智能正式登陆资本市场，在全国中小企业股份转让系统挂牌交易，股票简称：昌恩智能；股票代码：837544。
          </p> -->
          <p style="text-indent: 2em">
            深圳昌恩智能股份有限公司成立于1998年5月22日，是深耕于城市与建筑智能化、智慧交通、智慧能源等信息与智能化建设领域的综合解决方案提供商,昌恩智能是国家高新技术企业、深圳市专精特新中小企业,昌恩智能目前拥有三大业务板块，分别为“城市和建筑智能化解决方案”“智慧交通解决方案”与“智慧能源解决方案”。昌恩智能为新三板挂牌公司,股票代码:837544。
          </p>
          <br />
          <br />
          <p style="text-indent: 2em">
            昌恩智能拥有《广东省安全技术防范系统设计、施工、维修资格证(壹级)》《安防工程企业设计施工维护能力证书(壹级)》《建筑业企业资质证书--电子与智能化工程专业承包壹级》《建筑业企业资质证书--建筑机电安装工程专业承包二级》《建筑业企业资质证书--施工劳务》《安全生产许可证》《信息系统建设和服务能力等级证书(CS2)》《工程建设施工组织质量管理体系认证证书》、《环境管理体系认证证书》《职业健康安全管理体系认证证书》《知识产权合规管理体系认证证书》《信息技术服务管理体系认证证书
            》《信息安全管理体系认证证书》《CMMI3认证证书》《广东省科技厅网约车智能终端系统工程技术研究中心》《国家高新技术企业》《深圳市专精特新中小企业》《深圳知名品牌》等资质认证与荣誉。
          </p>
          <!-- <h1>集团架构</h1>
          <img src="../assets/img/introduction/编组 2@2x.png" alt="" /> -->
        </div>
        <!-- <div class="right"></div> -->
      </div>
    </main>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '../components/footer.vue'
export default {
  components: { Footer },
  name: 'introduction',
  data () {
    return {}
  },
  mounted () {
    this.prt()
  },
  methods: {
    prt () {
      console.log('1111111111111111111')
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 1201px) {
  .main {
    width: 1000px !important;
    /* background-color:green; */
  }
}

@media screen and (max-width: 1080px) {
  .main {
    width: 800px !important;
    /* background-color: red; */
  }
  main p {
    font-size: 16px !important;
  }
}

@media screen and (max-width: 1600px) and (min-width: 1200px) {
  .main {
    /* background-color: blue; */
    width: 1200px !important;
  }
}

/*  */
header {
  height: 500px;
}

.banner {
  height: 500px;
}

header h1 {
  margin-top: 163px;
  text-align: center;
  font-size: 48px;
  color: #ffffff;
  line-height: 65px;
  letter-spacing: 12px;
}

.main {
  width: 1470px;
  margin: 0 auto;
  margin: 74px auto 100px;
}

main h1 {
  /* margin: 56px auto 31px; */
  margin: 74px 0 41px;
  font-size: 38px;
  color: #140047;
  line-height: 39px;
  letter-spacing: 2px;
  text-align: center;
}

main p {
  /* width: 1170px; */
  width: 100%;
  /* height: 327px; */
  /* font-size: 15px; */
  font-size: 20px;
  font-weight: 400;
  color: #01021b;
  line-height: 27px;
  letter-spacing: 1px;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}

main img {
  /* width: 1195px; */
  width: 100%;
  height: 563px;
  margin-bottom: 100px;
}

.mainTop {
  height: 500px;
  position: relative;
}

.title {
  /* position: absolute;
  width: 311px;
  height: 49px;
  margin: 0 auto;
  top: 182px;
  font-size: 36px;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 49px;
  letter-spacing: 9px;
  white-space: nowrap; */
  font-size: 48px;
  top: 243px;
}
.main {
  min-height: calc(100vh - 760px);
}
</style>



// WEBPACK FOOTER //
// src/components/introduction.vue